export const STREAM_AD_OFFSET = 4; // NOTE: adjusting this value will also require CSS updates

// Post ads
// MOBILE
export const IN_POST_AD_FIRST_OFFSET_MOBILE = 2; // The offset of the first ad (relative to media items)
export const IN_POST_AD_OFFSET_MOBILE = 3; // The offset of subsequent ads (relative to media items)
// DESKTOP
export const IN_POST_AD_FIRST_OFFSET_DESKTOP = 3; // The offset of the first ad (relative to media items)
export const IN_POST_AD_OFFSET_DESKTOP = 4; // The offset of subsequent ads (relative to media items)
// Configure injection of post ads
export const HIDE_IN_POST_ADS = false;
export const HIDE_POST_RAIL_ADS = false;
export const HIDE_POST_FOOTER_ADS = false;

export const GALLERY_AD_OFFSET_AMP = 4;
